export default __webpack_public_path__ + "static/image039-f688dafd1372ee92496805617530a1d8.jpg";